import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'etoh-tooltip',
  template: `
    @if (value) {
    <div class="custom-tooltip card mat-padding-1 mat-elevation-z3">
      <div class="mat-caption">
        <b>{{ value }}</b>
      </div>
    </div>
    }
  `,
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent implements ITooltipAngularComp {
  value: string | undefined | null;

  agInit(params: { field: string } & ITooltipParams): void {
    this.value =
      params.valueFormatted === null ? params.value : params.valueFormatted;
  }
}
